import type { ClientsDataState } from '../clients/useClientsData';
import type { WazuhClientItem } from 'src/types/mindtime/wazuhDashboard';
import { previewPaged } from './previewUtils';

const PREVIEW_CLIENT_ROWS: WazuhClientItem[] = [
  {
    clientId: 'preview-org-1',
    clientName: 'Acme Financial',
    status: 'Active',
    risk: 'Low',
    securityScore: 82,
    endpointCount: 12,
  },
  {
    clientId: 'preview-org-2',
    clientName: 'Vertex Solutions',
    status: 'Active',
    risk: 'Medium',
    securityScore: 76,
    endpointCount: 8,
  },
  {
    clientId: 'preview-org-3',
    clientName: 'Nexus Dynamics',
    status: 'Attention',
    risk: 'High',
    securityScore: 68,
    endpointCount: 15,
  },
  {
    clientId: 'preview-org-4',
    clientName: 'Pinnacle Group',
    status: 'Active',
    risk: 'Low',
    securityScore: 91,
    endpointCount: 6,
  },
];

export const getClientsPreviewState = (): ClientsDataState => ({
  loading: false,
  summaryLoading: false,
  summary: {
    totalClients: 4,
    protectedEndpoints: {
      total: 41,
      warning: 5,
      critical: 2,
    },
    clientsRequiringAttention: 2,
    clientsRequiringAttentionIds: ['preview-org-3', 'preview-org-2'],
  },
  items: previewPaged(PREVIEW_CLIENT_ROWS, 0, 10),
});
